export function saveTimestamp(level, duration) {
  // hack to unmount component (change key, based on timestamp)
  setTimeout(() => {
    const activeTimestamp = global.localStorage.getItem(`activeTimestamp`);
    if (activeTimestamp) {
      global.localStorage.setItem(`timestamp${activeTimestamp}`, Date.now());
    } else {
      global.localStorage.setItem(`timestamp${level}`, Date.now());
    }
    window.dispatchEvent(new Event('storage'));
  }, duration);
}
